import { useQuery } from '@tanstack/react-query';
import { API_BASE } from './api-base';
import { apiFetch } from './api-client';
import { queryKeys } from './query-client';

export interface SiteInfo {
  siteDisplayName: string | null;
  businessName: string | null;
  metaSiteId: string;
  /** The account's own Wix sites — what the Wix connector card names and links to. */
  sites?: { id: string; name: string; viewUrl: string | null; published: boolean | null }[];
}

async function fetchSiteInfo(): Promise<SiteInfo | null> {
  const res = await apiFetch(`${API_BASE}/api/site-info`, { credentials: 'include' });
  if (!res.ok) return null;
  const data = (await res.json()) as { site?: SiteInfo | null };
  return data.site ?? null;
}

/** The Wix site behind the account — its display name for the map's Wix card. Null when unknown. */
export function useSiteInfo(): SiteInfo | null {
  const query = useQuery({ queryKey: queryKeys.siteInfo, queryFn: fetchSiteInfo, staleTime: 5 * 60_000 });
  return query.data ?? null;
}
